export default class TournamentBetTemplate {
  constructor(options) {
    this.active = options.active;
    this.id = options.id;
    this.name = options.name;
    this.types = options.types;
    this.sports = options.sports;
    this.tournaments = options.tournaments;
    this.bets = options.bets;
  }
}
